import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'wp-layout',
  templateUrl: './page.layout.html',
  imports: [RouterOutlet],
})
export class PageLayout {}
